/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import type { Observable } from 'rxjs';
import type { AssignmentId } from '../models/AssignmentId';
import type { CameraChannelId } from '../models/CameraChannelId';
import type { CameraChannelName } from '../models/CameraChannelName';
import type { CameraChannelNumber } from '../models/CameraChannelNumber';
import type { CameraChannelsAll } from '../models/CameraChannelsAll';
import type { CameraQueueCommon } from '../models/CameraQueueCommon';
import type { CameraQueueStatus } from '../models/CameraQueueStatus';
import type { CameraQueueUpdatedAt } from '../models/CameraQueueUpdatedAt';
import type { CameraRecorderChannels } from '../models/CameraRecorderChannels';
import type { CameraRecorderPhoneNumber } from '../models/CameraRecorderPhoneNumber';
import type { CameraRecorderSince } from '../models/CameraRecorderSince';
import type { CameraRecorderSinceUntil } from '../models/CameraRecorderSinceUntil';
import type { CameraRecorderSn } from '../models/CameraRecorderSn';
import type { CameraRecorderUntil } from '../models/CameraRecorderUntil';
import type { Sim } from '../models/Sim';
import type { VehicleId } from '../models/VehicleId';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
@Injectable({
    providedIn: 'root',
})
export class CamerasService {
    constructor(public readonly http: HttpClient) {}
    /**
     * Register
     * Register camera recorder
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public cameraRegister(
        requestBody: {
            channels: Array<CameraRecorderChannels>;
            phone_number?: CameraRecorderPhoneNumber;
            sim?: Sim;
            sn: CameraRecorderSn;
        },
    ): Observable<void> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/cameras/',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Not enough rights`,
                409: `Conflict`,
                500: `Server error`,
            },
        });
    }
    /**
     * Get camera queue
     * Get camera queue
     * @param vehicleId Vehicle ID
     * @param startDate Optional lower bound — only recordings starting at or after this time
     * @param endDate Optional upper bound — only recordings ending at or before this time
     * @returns any Download history
     * @throws ApiError
     */
    public cameraQueue(
        vehicleId: string,
        startDate?: string | null,
        endDate?: string | null,
    ): Observable<Array<(CameraQueueCommon & {
        channel: CameraChannelsAll;
        /**
         * Download URL (only if status is 5)
         */
        download_url?: string | null;
        /**
         * Camera queue ID
         */
        id: string;
        /**
         * Download/render progress percent (0-100), only meaningful while status is 3 or 4
         */
        progress?: number | null;
        status: CameraQueueStatus;
        updated_at: CameraQueueUpdatedAt;
    })>> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/vehicles/{vehicle_id}/camera/queue',
            path: {
                'vehicle_id': vehicleId,
            },
            query: {
                'start_date': startDate,
                'end_date': endDate,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Not enough rights`,
                404: `Not found`,
                500: `Server error`,
            },
        });
    }
    /**
     * Request camera recording
     * Request camera recording
     * @param vehicleId Vehicle ID
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public cameraRequest(
        vehicleId: string,
        requestBody: (CameraQueueCommon & {
            channel: CameraChannelsAll;
            /**
             * User ID to attribute the recording request to. If omitted, defaults to the authenticated user.
             */
            user_id?: string | null;
        }),
    ): Observable<void> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/vehicles/{vehicle_id}/camera/queue',
            path: {
                'vehicle_id': vehicleId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Not enough rights`,
                404: `Not found`,
                409: `Conflict`,
                412: `Precondition error`,
                500: `Server error`,
            },
        });
    }
    /**
     * Camera live
     * Get live video stream
     * @param vehicleId Vehicle ID
     * @param channel Channel
     * @param type Type
     * @param substream Substream
     * @returns any Queue
     * @throws ApiError
     */
    public cameraLive(
        vehicleId: string,
        channel: number,
        type: 'rtsp' | 'hls' | 'web' | 'web_hls' = 'hls',
        substream: boolean = true,
    ): Observable<{
        /**
         * URL
         */
        url: string;
    }> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/vehicles/{vehicle_id}/camera/live',
            path: {
                'vehicle_id': vehicleId,
            },
            query: {
                'type': type,
                'substream': substream,
                'channel': channel,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Not enough rights`,
                404: `Not found`,
                412: `Precondition error`,
                500: `Server error`,
            },
        });
    }
    /**
     * Edit camera channel
     * Edit camera channel
     * @param vehicleId Vehicle ID
     * @param channelId Channel ID
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public cameraChannelEdit(
        vehicleId: string,
        channelId: string,
        requestBody: {
            name?: string | null;
        },
    ): Observable<void> {
        return __request(OpenAPI, this.http, {
            method: 'PUT',
            url: '/vehicles/{vehicle_id}/camera/channel/{channel_id}',
            path: {
                'vehicle_id': vehicleId,
                'channel_id': channelId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Not enough rights`,
                404: `Not found`,
                500: `Server error`,
            },
        });
    }
    /**
     * Camera channels
     * List camera channels
     * @param vehicleId Vehicle ID
     * @returns any Channels
     * @throws ApiError
     */
    public cameraChannel(
        vehicleId: string,
    ): Observable<Array<{
        channel: CameraChannelNumber;
        id: CameraChannelId;
        name: CameraChannelName;
    }>> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/vehicles/{vehicle_id}/camera/channel/',
            path: {
                'vehicle_id': vehicleId,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Not enough rights`,
                404: `Not found`,
                500: `Server error`,
            },
        });
    }
    /**
     * Camera status
     * Get camera status and connectivity
     * @param vehicleId Vehicle ID
     * @returns any Camera status and connectivity
     * @throws ApiError
     */
    public cameraStatus(
        vehicleId: string,
    ): Observable<{
        /**
         * Per-channel video-lost flag. Index 0 = channel 1.
         */
        channelVideoLost: Array<boolean>;
        gnssAntennaMissedOrCut: boolean;
        gnssAntennaShort: boolean;
        gnssModuleFault: boolean;
        hardDiskPowerOutage: boolean;
        hardDiskPresent: boolean;
        ignition: boolean;
        latitude: number;
        longitude: number;
        /**
         * Active network interface
         */
        network: 'mobile' | 'wifi' | 'wired' | null;
        /**
         * Whether the recorder is currently connected
         */
        online: boolean;
        /**
         * Signal strength, 0-5 (0 module absent … 5 extremely strong).
         */
        signalStrength: number;
    }> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/vehicles/{vehicle_id}/camera/',
            path: {
                'vehicle_id': vehicleId,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Not enough rights`,
                404: `Not found`,
                412: `Precondition error`,
                500: `Server error`,
            },
        });
    }
    /**
     * Camera vehicle assignment edit
     * Camera recorder vehicle assignment edit
     * @param assignmentId Assignment ID
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public cameraAssignVehicleEdit(
        assignmentId: string,
        requestBody: CameraRecorderSinceUntil,
    ): Observable<void> {
        return __request(OpenAPI, this.http, {
            method: 'PUT',
            url: '/cameras/assign_vehicle/{assignment_id}',
            path: {
                'assignment_id': assignmentId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Not enough rights`,
                404: `Not found`,
                412: `Precondition error`,
                500: `Server error`,
            },
        });
    }
    /**
     * Update camera queue status
     * Update camera queue status
     * @param sn Camera recorder serial number
     * @param queueId Queue ID
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public cameraQueueUpdate(
        sn: string,
        queueId: string,
        requestBody: {
            download_url?: string | null;
            /**
             * Download/render progress percent (0-100)
             */
            progress?: number | null;
            status: CameraQueueStatus;
        },
    ): Observable<void> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/cameras/{sn}/queue/{queue_id}',
            path: {
                'sn': sn,
                'queue_id': queueId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Not enough rights`,
                404: `Not found`,
                500: `Server error`,
            },
        });
    }
    /**
     * Delete camera queue
     * Delete camera queue
     * @param sn Camera recorder serial number
     * @param queueId Queue ID
     * @returns void
     * @throws ApiError
     */
    public cameraQueueDelete(
        sn: string,
        queueId: string,
    ): Observable<void> {
        return __request(OpenAPI, this.http, {
            method: 'DELETE',
            url: '/cameras/{sn}/queue/{queue_id}',
            path: {
                'sn': sn,
                'queue_id': queueId,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Not enough rights`,
                404: `Not found`,
                500: `Server error`,
            },
        });
    }
    /**
     * Assign camera recorder to the vehicle
     * Assign camera recorder to the vehicle
     * @param sn Camera recorder serial number
     * @param vehicleId Vehicle ID
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public cameraAssignVehicle(
        sn: string,
        vehicleId: string,
        requestBody: CameraRecorderSinceUntil,
    ): Observable<void> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/cameras/{sn}/assign_vehicle/{vehicle_id}',
            path: {
                'sn': sn,
                'vehicle_id': vehicleId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Not enough rights`,
                404: `Not found`,
                409: `Conflict`,
                500: `Server error`,
            },
        });
    }
    /**
     * Camera vehicle assignment
     * Camera recorder vehicle assignment
     * @param sn Camera recorder serial number
     * @returns any Assignments
     * @throws ApiError
     */
    public cameraAssignGet(
        sn: string,
    ): Observable<Array<({
        id: AssignmentId;
        vehicle_id: VehicleId;
    } & CameraRecorderSince & CameraRecorderUntil)>> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/cameras/{sn}/assign_vehicle/',
            path: {
                'sn': sn,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Not enough rights`,
                404: `Not found`,
                500: `Server error`,
            },
        });
    }
    /**
     * Delete
     * Delete camera recorder
     * @param sn Camera recorder serial number
     * @param permanent
     * @returns void
     * @throws ApiError
     */
    public cameraDelete(
        sn: string,
        permanent: boolean = false,
    ): Observable<void> {
        return __request(OpenAPI, this.http, {
            method: 'DELETE',
            url: '/cameras/{sn}/',
            path: {
                'sn': sn,
            },
            query: {
                'permanent': permanent,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Not enough rights`,
                404: `Not found`,
                500: `Server error`,
            },
        });
    }
    /**
     * Edit
     * Edit camera recorder
     * @param sn Camera recorder serial number
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public cameraEdit(
        sn: string,
        requestBody: {
            phone_number?: CameraRecorderPhoneNumber;
            sim?: Sim;
        },
    ): Observable<void> {
        return __request(OpenAPI, this.http, {
            method: 'PUT',
            url: '/cameras/{sn}/',
            path: {
                'sn': sn,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Not enough rights`,
                404: `Not found`,
                412: `Precondition error`,
                500: `Server error`,
            },
        });
    }
}
